(function () {
  const NAMESPACE = 'NYGL911LaunchTracking';
  const EVENT_HUB_VIEW = 'nygl_911_hub_view';
  const EVENT_HUB_TO_PDP = 'nygl_911_hub_to_pdp';
  const EVENT_ENTRY_CLICK = 'nygl_911_entry_click';
  const EVENT_SCALE_SELECT = 'nygl_tt_scale_select';
  const HUB_SELECTOR = '[data-nygl-911-hub][data-nygl-911-program-phase]';
  const HUB_ROUTE_SELECTOR =
    '[data-nygl-911-route-click][data-nygl-911-route="twin-towers-pdp"]';
  const ANNOUNCEMENT_SELECTOR =
    '[data-announcement-bar] > a.announcement-bar-link[href="/pages/september-11-tribute"]';
  const SCALE_BY_VARIANT_ID = {
    '43653226234068': 'desk',
    '43653226201300': 'signature',
    '44486202392788': 'collector',
  };
  const CTA_LOCATION_BY_PLACEMENT = {
    object: 'object',
    'scale-card': 'scale_card',
    closing: 'closing',
  };

  if (window[NAMESPACE] && window[NAMESPACE].isNygl911LaunchTracking) {
    window[NAMESPACE].init();
    return;
  }

  let initialized = false;
  let hubViewEmitted = false;

  function dataLayerQueue() {
    return Array.isArray(window.dataLayer) ? window.dataLayer : null;
  }

  function pushToDataLayer(payload) {
    const queue = dataLayerQueue();

    if (!queue) return false;

    queue.push(payload);
    return true;
  }

  function normalizeVariantId(value) {
    return value ? String(value) : '';
  }

  function targetScaleFor(placement, variantId) {
    if (placement === 'object' || placement === 'closing') return 'general';

    return SCALE_BY_VARIANT_ID[variantId] || '';
  }

  function emitHubView() {
    if (hubViewEmitted) return false;

    const hub = document.querySelector(HUB_SELECTOR);
    if (!hub) return false;

    const programPhase = hub.getAttribute('data-nygl-911-program-phase');
    if (!programPhase) return false;

    hubViewEmitted = true;

    return pushToDataLayer({
      event: EVENT_HUB_VIEW,
      program_phase: programPhase,
    });
  }

  function emitHubToPdp(link) {
    if (!link) return false;

    const placement = link.getAttribute('data-nygl-911-route-placement');
    const variantId = normalizeVariantId(link.getAttribute('data-nygl-911-variant-id'));
    const ctaLocation = CTA_LOCATION_BY_PLACEMENT[placement] || '';
    const targetScale = targetScaleFor(placement, variantId);

    if (!ctaLocation || !targetScale || !variantId) return false;

    return pushToDataLayer({
      event: EVENT_HUB_TO_PDP,
      cta_location: ctaLocation,
      target_scale: targetScale,
      target_variant_id: variantId,
    });
  }

  function emitEntryClick(link) {
    if (!link || !link.matches(ANNOUNCEMENT_SELECTOR)) return false;

    return pushToDataLayer({
      event: EVENT_ENTRY_CLICK,
      entry_surface: 'announcement_bar',
      destination_type: 'editorial_hub',
    });
  }

  function emitScaleSelect(variantId) {
    const normalizedVariantId = normalizeVariantId(variantId);
    const ttScale = SCALE_BY_VARIANT_ID[normalizedVariantId] || '';

    if (!ttScale) return false;

    return pushToDataLayer({
      event: EVENT_SCALE_SELECT,
      tt_scale: ttScale,
      variant_id: normalizedVariantId,
    });
  }

  function handleDocumentClick(event) {
    if (!event.target || !event.target.closest) return;

    emitHubToPdp(event.target.closest(HUB_ROUTE_SELECTOR));
    emitEntryClick(event.target.closest(ANNOUNCEMENT_SELECTOR));
  }

  function init() {
    if (initialized) {
      emitHubView();
      return;
    }

    initialized = true;
    document.addEventListener('click', handleDocumentClick);
    emitHubView();
  }

  window[NAMESPACE] = {
    isNygl911LaunchTracking: true,
    init,
    emitScaleSelect,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
